import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import api from "../../utils/api";
import { FILE_BASE_URL } from "../../utils/api";

const UserViewActivist = () => {
  const { id } = useParams();
  const [activist, setActivist] = useState(null);
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [children, setChildren] = useState([]);
  const [statements, setStatements] = useState([]);
  const [videos, setVideos] = useState([]);
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    fetchActivist();
  }, []);

  const fetchActivist = async () => {
    try {
      const response = await api.get(`/activists/${id}`);
      if (response.data && response.data.data) {
        setActivist(response.data.data);

        if (response.data.data.images) {
          try {
            setImages(parseArrayField(response.data.data.images));
          } catch (e) {
            setImages([]);
          }
        }

        if (response.data.data.children_details) {
          try {
            setChildren(parseArrayField(response.data.data.children_details));
          } catch (e) {
            setChildren([]);
          }
        }

        // تحميل التصريحات
        if (response.data.data.statements) {
          try {
            setStatements(parseArrayField(response.data.data.statements));
          } catch (e) {
            console.error("فشل في قراءة التصريحات:", e);
            setStatements([]);
          }
        }

        // تحميل الفيديوهات
        if (response.data.data.videos) {
          try {
            setVideos(parseArrayField(response.data.data.videos));
          } catch (e) {
            console.error("فشل في قراءة الفيديوهات:", e);
            setVideos([]);
          }
        }

        // تحميل المرفقات
        if (response.data.data.attachments) {
          try {
            setAttachments(parseArrayField(response.data.data.attachments));
          } catch (e) {
            console.error("فشل في قراءة المرفقات:", e);
            setAttachments([]);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching activist:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("ar-EG");
  };

  const parseArrayField = (field) => {
    if (!field) return [];
    if (Array.isArray(field)) return field;
    try {
      return JSON.parse(field);
    } catch {
      return [];
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const handleShare = () => {
    const text = `بيانات الناشط: ${activist.full_name}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  if (loading) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          borderRadius: "20px",
          padding: "40px",
          textAlign: "center",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)"
        }}>
          <Spinner size="lg" color="primary" />
          <p style={{ marginTop: "20px", fontSize: "18px" }}>جاري تحميل بيانات الناشط...</p>
        </div>
      </div>
    );
  }

  if (!activist) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          background: "white",
          borderRadius: "20px",
          padding: "40px",
          textAlign: "center",
          boxShadow: "0 20px 40px rgba(0,0,0,0.1)"
        }}>
          <i className="mdi mdi-alert-circle" style={{ fontSize: "64px", color: "#e74c3c" }}></i>
          <h4 style={{ marginTop: "20px" }}>لم يتم العثور على بيانات الناشط</h4>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      padding: "20px"
    }}>
      <div className="container" style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <div style={{
          background: "white",
          borderRadius: "25px",
          overflow: "hidden",
          boxShadow: "0 25px 50px rgba(0,0,0,0.15)"
        }}>

          <div style={{
            background: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
            color: "white",
            padding: "40px",
            position: "relative"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
              <div style={{ flexShrink: 0 }}>
                {activist.profile_image ? (
                  <img
                    src={`${FILE_BASE_URL}/uploads/images/${activist.profile_image}`}
                    alt="صورة الناشط"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "20px",
                      objectFit: "cover",
                      border: "4px solid rgba(255,255,255,0.2)",
                      boxShadow: "0 15px 30px rgba(0,0,0,0.3)"
                    }}
                  />
                ) : (
                  <div style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "20px",
                    background: "linear-gradient(135deg, #3498db 0%, #2980b9 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "4px solid rgba(255,255,255,0.2)",
                    boxShadow: "0 15px 30px rgba(0,0,0,0.3)"
                  }}>
                    <i className="mdi mdi-account" style={{ fontSize: "60px", opacity: 0.8 }}></i>
                  </div>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h1 style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  marginBottom: "10px",
                  textShadow: "0 2px 4px rgba(0,0,0,0.3)"
                }}>
                  {activist.full_name || "بدون اسم"}
                </h1>

                <div style={{
                  display: "inline-block",
                  background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                  padding: "8px 20px",
                  borderRadius: "20px",
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  marginBottom: "20px",
                  boxShadow: "0 8px 16px rgba(231,76,60,0.3)"
                }}>
                  {activist.specialization || "بدون تخصص"}
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px" }}>
                  {activist.mobile1 && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-cellphone" style={{ fontSize: "18px", color: "#3498db" }}></i>
                      <span>{activist.mobile1}</span>
                    </div>
                  )}
                  {activist.email && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-email" style={{ fontSize: "18px", color: "#3498db" }}></i>
                      <span>{activist.email}</span>
                    </div>
                  )}
                  {(activist.city_or_area || activist.country_province) && (
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <i className="mdi mdi-map-marker" style={{ fontSize: "18px", color: "#3498db" }}></i>
                      <span>{[activist.city_or_area, activist.country_province].filter(Boolean).join(", ")}</span>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ textAlign: "center" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  <button
                    onClick={handlePrint}
                    style={{
                      background: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
                      border: "none",
                      color: "white",
                      padding: "12px 24px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      boxShadow: "0 8px 16px rgba(46,204,113,0.3)",
                      minWidth: "120px"
                    }}
                  >
                    <i className="mdi mdi-printer me-2"></i>
                    طباعة
                  </button>

                  <button
                    onClick={handleShare}
                    style={{
                      background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                      border: "none",
                      color: "white",
                      padding: "12px 24px",
                      borderRadius: "20px",
                      fontSize: "14px",
                      fontWeight: "600",
                      cursor: "pointer",
                      boxShadow: "0 8px 16px rgba(37,211,102,0.3)",
                      minWidth: "120px"
                    }}
                  >
                    <i className="mdi mdi-whatsapp me-2"></i>
                    مشاركة
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div style={{ padding: "40px" }}>

            {activist.bio && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #3498db",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #3498db 0%, #2980b9 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-account-details" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  نبذة عن الناشط
                </h3>
                <div style={{
                  background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                  padding: "25px",
                  borderRadius: "15px",
                  fontSize: "1.1rem",
                  lineHeight: "1.8",
                  color: "#2c3e50",
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                }}>
                  {activist.bio.replace(/<[^>]*>/g, "")}
                </div>
              </div>
            )}

            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
              marginBottom: "40px"
            }}>

              <div style={{
                background: "white",
                borderRadius: "20px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                border: "1px solid rgba(52,152,219,0.1)",
                transition: "transform 0.3s ease"
              }}>
                <h4 style={{
                  color: "#2c3e50",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-account" style={{ fontSize: "16px", color: "white" }}></i>
                  </div>
                  المعلومات الشخصية
                </h4>

                {[
                  { label: "الاسم الكامل", value: activist.full_name, icon: "account" },
                  { label: "رقم الهوية", value: activist.id_number, icon: "card-account-details" },
                  { label: "تاريخ الميلاد", value: formatDate(activist.birth_date), icon: "calendar" },
                  { label: "الجنس", value: activist.gender === "male" ? "ذكر" : activist.gender === "female" ? "أنثى" : activist.gender, icon: "human-male-female" },
                  { label: "الحالة الاجتماعية", value: activist.marital_status, icon: "heart" },
                  { label: "عدد الأطفال", value: activist.children_count, icon: "baby" }
                ].filter(item => item.value).map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 0",
                    borderBottom: index < 4 ? "1px solid #f1f2f6" : "none"
                  }}>
                    <i className={`mdi mdi-${item.icon}`} style={{
                      fontSize: "18px",
                      color: "#e74c3c",
                      marginLeft: "12px",
                      minWidth: "18px"
                    }}></i>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "600", color: "#2c3e50", fontSize: "13px", marginBottom: "2px" }}>
                        {item.label}
                      </div>
                      <div style={{ color: "#34495e", fontSize: "15px" }}>{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div style={{
                background: "white",
                borderRadius: "20px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                border: "1px solid rgba(52,152,219,0.1)",
                transition: "transform 0.3s ease"
              }}>
                <h4 style={{
                  color: "#2c3e50",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-phone" style={{ fontSize: "16px", color: "white" }}></i>
                  </div>
                  معلومات الاتصال
                </h4>

                {[
                  { label: "الجوال الأول", value: activist.mobile1, icon: "cellphone" },
                  { label: "الجوال الثاني", value: activist.mobile2, icon: "cellphone" },
                  { label: "البريد الإلكتروني", value: activist.email, icon: "email" },
                  { label: "واتساب", value: activist.whatsapp1, icon: "whatsapp" },
                  { label: "فيسبوك", value: activist.facebook, icon: "facebook" }
                ].filter(item => item.value).map((item, index) => (
                  <div key={index} style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 0",
                    borderBottom: index < 4 ? "1px solid #f1f2f6" : "none"
                  }}>
                    <i className={`mdi mdi-${item.icon}`} style={{
                      fontSize: "18px",
                      color: "#27ae60",
                      marginLeft: "12px",
                      minWidth: "18px"
                    }}></i>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "600", color: "#2c3e50", fontSize: "13px", marginBottom: "2px" }}>
                        {item.label}
                      </div>
                      <div style={{ color: "#34495e", fontSize: "15px" }}>{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

            {parseArrayField(activist.political_orientation).length > 0 && (
              <div style={{
                background: "white",
                borderRadius: "20px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                border: "1px solid rgba(142,68,173,0.1)",
                transition: "transform 0.3s ease",
                gridColumn: "1 / -1"
              }}>
                <h4 style={{
                  color: "#2c3e50",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-flag" style={{ fontSize: "16px", color: "white" }}></i>
                  </div>
                  الميول السياسية ({parseArrayField(activist.political_orientation).length})
                </h4>

                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "15px",
                  justifyContent: "center",
                  alignItems: "center"
                }}>
                  {parseArrayField(activist.political_orientation).map((orientation, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)",
                      color: "white",
                      padding: "15px 30px",
                      borderRadius: "30px",
                      fontSize: "16px",
                      fontWeight: "600",
                      boxShadow: "0 6px 20px rgba(142,68,173,0.4)",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "10px",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      minWidth: "180px",
                      justifyContent: "center"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px) scale(1.05)";
                      e.currentTarget.style.boxShadow = "0 12px 30px rgba(142,68,173,0.6)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0) scale(1)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(142,68,173,0.4)";
                    }}
                    >
                      <i className="mdi mdi-flag" style={{ fontSize: "20px" }}></i>
                      {orientation}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{
                background: "white",
                borderRadius: "20px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                border: "1px solid rgba(52,152,219,0.1)",
                transition: "transform 0.3s ease"
              }}>
                <h4 style={{
                  color: "#2c3e50",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #3498db 0%, #2980b9 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-map-marker" style={{ fontSize: "16px", color: "white" }}></i>
                  </div>
                  العنوان والموقع
                </h4>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
                  <div style={{
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                    borderRadius: "15px",
                    padding: "20px",
                    border: "1px solid rgba(52,152,219,0.1)"
                  }}>
                    <h6 style={{ color: "#3498db", fontWeight: "bold", marginBottom: "15px" }}>
                      تفاصيل العنوان
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>البلد:</strong> {activist.country || "-"}</div>
                      <div><strong>المحافظة:</strong> {activist.country_province || "-"}</div>
                      <div><strong>المدينة/المنطقة:</strong> {activist.city_or_area || "-"}</div>
                      <div><strong>تفاصيل العنوان:</strong> {activist.address_details || "-"}</div>
                    </div>
                  </div>

                  <div style={{
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                    borderRadius: "15px",
                    padding: "20px",
                    border: "1px solid rgba(52,152,219,0.1)"
                  }}>
                    <h6 style={{ color: "#3498db", fontWeight: "bold", marginBottom: "15px" }}>
                      الموقع الجغرافي
                    </h6>
                    {activist.map_address ? (
                      <div style={{
                        border: "2px dashed #3498db",
                        borderRadius: "10px",
                        padding: "20px",
                        textAlign: "center",
                        background: "rgba(52,152,219,0.05)"
                      }}>
                        <i className="mdi mdi-map" style={{ fontSize: "32px", color: "#3498db", marginBottom: "10px" }}></i>
                        <div style={{ fontSize: "14px", color: "#7f8c8d" }}>
                          {activist.map_address}
                        </div>
                      </div>
                    ) : (
                      <div style={{
                        border: "2px dashed #bdc3c7",
                        borderRadius: "10px",
                        padding: "20px",
                        textAlign: "center",
                        background: "#f8f9fa"
                      }}>
                        <i className="mdi mdi-map-marker-off" style={{ fontSize: "32px", color: "#bdc3c7", marginBottom: "10px" }}></i>
                        <div style={{ fontSize: "14px", color: "#7f8c8d" }}>
                          لا يوجد موقع محدد
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div style={{
                background: "white",
                borderRadius: "20px",
                padding: "30px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                border: "1px solid rgba(155,89,182,0.1)",
                transition: "transform 0.3s ease"
              }}>
                <h4 style={{
                  color: "#2c3e50",
                  marginBottom: "25px",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-briefcase" style={{ fontSize: "16px", color: "white" }}></i>
                  </div>
                  العمل والتعليم
                </h4>

                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
                  <div style={{
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                    borderRadius: "15px",
                    padding: "20px",
                    border: "1px solid rgba(155,89,182,0.1)"
                  }}>
                    <h6 style={{ color: "#9b59b6", fontWeight: "bold", marginBottom: "15px" }}>
                      التعليم والتخصص
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>التخصص:</strong> {activist.specialization || "-"}</div>
                      <div><strong>اسم الجامعة:</strong> {activist.university_name || "-"}</div>
                    </div>
                  </div>

                  <div style={{
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                    borderRadius: "15px",
                    padding: "20px",
                    border: "1px solid rgba(155,89,182,0.1)"
                  }}>
                    <h6 style={{ color: "#9b59b6", fontWeight: "bold", marginBottom: "15px" }}>
                      معلومات العمل
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>مكان العمل الأخير:</strong> {activist.last_work_place || "-"}</div>
                      <div><strong>قطاع العمل:</strong>
                        {parseArrayField(activist.work_sector).length > 0 ? (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "5px" }}>
                            {parseArrayField(activist.work_sector).map((sector, index) => (
                              <span key={index} style={{
                                background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)",
                                color: "white",
                                padding: "4px 12px",
                                borderRadius: "15px",
                                fontSize: "12px",
                                fontWeight: "500"
                              }}>
                                {sector}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: "#7f8c8d", marginTop: "5px" }}> - </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={{
                    background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                    borderRadius: "15px",
                    padding: "20px",
                    border: "1px solid rgba(155,89,182,0.1)"
                  }}>
                    <h6 style={{ color: "#9b59b6", fontWeight: "bold", marginBottom: "15px" }}>
                      الارتباطات المهنية
                    </h6>
                    <div style={{ display: "grid", gap: "12px" }}>
                      <div><strong>المؤسسة المرتبطة:</strong> {activist.linked_institution || "-"}</div>
                      <div><strong>الصحفيون المرتبطون:</strong>
                        {parseArrayField(activist.linked_journalists).length > 0 ? (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "5px" }}>
                            {parseArrayField(activist.linked_journalists).map((journalist, index) => (
                              <span key={index} style={{
                                background: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
                                color: "white",
                                padding: "4px 12px",
                                borderRadius: "15px",
                                fontSize: "12px",
                                fontWeight: "500"
                              }}>
                                {journalist}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: "#7f8c8d", marginTop: "5px" }}> - </span>
                        )}
                      </div>
                      <div><strong>الناشطون المرتبطون:</strong>
                        {parseArrayField(activist.linked_activists).length > 0 ? (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "5px" }}>
                            {parseArrayField(activist.linked_activists).map((peer, index) => (
                              <span key={index} style={{
                                background: "linear-gradient(135deg, #f39c12 0%, #f1c40f 100%)",
                                color: "white",
                                padding: "4px 12px",
                                borderRadius: "15px",
                                fontSize: "12px",
                                fontWeight: "500"
                              }}>
                                {peer}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span style={{ color: "#7f8c8d", marginTop: "5px" }}> - </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {statements && statements.length > 0 && (
                <div style={{ marginBottom: "40px" }}>
                  <h3 style={{
                    color: "#2c3e50",
                    marginBottom: "20px",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    borderBottom: "3px solid #f39c12",
                    paddingBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px"
                  }}>
                    <div style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #f39c12 0%, #e67e22 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="mdi mdi-comment-quote" style={{ fontSize: "18px", color: "white" }}></i>
                    </div>
                    التصريحات والأقوال ({statements.length})
                  </h3>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "20px" }}>
                    {statements.map((statement, index) => (
                      <div key={index} style={{
                        background: "linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)",
                        borderRadius: "15px",
                        padding: "25px",
                        border: "1px solid rgba(243,156,18,0.2)",
                        boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                      }}>
                        <h6 style={{ color: "#f39c12", fontWeight: "bold", marginBottom: "15px", fontSize: "1.1rem" }}>
                          {statement.title || `تصريح ${index + 1}`}
                        </h6>
                        <p style={{
                          color: "#2c3e50",
                          lineHeight: "1.6",
                          marginBottom: "15px",
                          fontStyle: "italic"
                        }}>
                          "{statement.content}"
                        </p>
                        {statement.date && (
                          <div style={{
                            fontSize: "13px",
                            color: "#7f8c8d",
                            display: "flex",
                            alignItems: "center",
                            gap: "5px"
                          }}>
                            <i className="mdi mdi-calendar"></i>
                            {new Date(statement.date).toLocaleDateString('ar-EG')}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {videos && videos.length > 0 && (
                <div style={{ marginBottom: "40px" }}>
                  <h3 style={{
                    color: "#2c3e50",
                    marginBottom: "20px",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    borderBottom: "3px solid #e74c3c",
                    paddingBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px"
                  }}>
                    <div style={{
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="mdi mdi-video" style={{ fontSize: "18px", color: "white" }}></i>
                    </div>
                    مقاطع الفيديو ({videos.length})
                  </h3>

                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
                    {videos.map((video, index) => (
                      <div key={index} style={{
                        background: "linear-gradient(135deg, #ffeaea 0%, #ffcccc 100%)",
                        borderRadius: "15px",
                        padding: "20px",
                        border: "1px solid rgba(231,76,60,0.2)",
                        boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
                        textAlign: "center"
                      }}>
                        <div style={{
                          width: "60px",
                          height: "60px",
                          borderRadius: "50%",
                          background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 15px",
                          boxShadow: "0 4px 12px rgba(231,76,60,0.3)"
                        }}>
                          <i className="mdi mdi-youtube" style={{ fontSize: "24px", color: "white" }}></i>
                        </div>
                        <h6 style={{ color: "#e74c3c", fontWeight: "bold", marginBottom: "10px" }}>
                          مقطع فيديو {index + 1}
                        </h6>
                        <a href={video} target="_blank" rel="noopener noreferrer" style={{
                          background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                          color: "white",
                          padding: "10px 20px",
                          borderRadius: "25px",
                          textDecoration: "none",
                          fontSize: "14px",
                          fontWeight: "500",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "8px",
                          boxShadow: "0 4px 12px rgba(231,76,60,0.3)",
                          transition: "transform 0.2s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                        >
                          <i className="mdi mdi-play" style={{ fontSize: "16px" }}></i>
                          مشاهدة الفيديو
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>

            {children && children.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #e74c3c",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-baby" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  تفاصيل الأطفال
                </h3>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: "20px"
                }}>
                  {children.map((child, index) => (
                    <div key={index} style={{
                      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                      borderRadius: "15px",
                      padding: "20px",
                      border: "1px solid rgba(231,76,60,0.1)",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.05)"
                    }}>
                      <h6 style={{ color: "#e74c3c", fontWeight: "bold", marginBottom: "15px" }}>
                        الطفل {index + 1}
                      </h6>
                      <div style={{ display: "grid", gap: "8px" }}>
                        <div><strong>الاسم:</strong> {child.name || "-"}</div>
                        <div><strong>العمر:</strong> {child.age || "-"}</div>
                        <div><strong>الجنس:</strong> {child.gender === "male" ? "ذكر" : child.gender === "female" ? "أنثى" : child.gender || "-"}</div>
                        <div><strong>الحالة الصحية:</strong> {child.health_status || "-"}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {images && images.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #27ae60",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-image-multiple" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  معرض الصور ({images.length})
                </h3>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                  gap: "20px"
                }}>
                  {images.map((image, index) => (
                    <div key={index} style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                      transition: "transform 0.3s ease",
                      cursor: "pointer"
                    }}
                    onClick={() => window.open(`${FILE_BASE_URL}/uploads/images/${image}`, "_blank")}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                    >
                      <img
                        src={`${FILE_BASE_URL}/uploads/images/${image}`}
                        alt={`صورة ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "150px",
                          objectFit: "cover"
                        }}
                      />
                      <div style={{
                        padding: "10px",
                        background: "white",
                        textAlign: "center",
                        fontSize: "13px",
                        color: "#7f8c8d"
                      }}>
                        صورة {index + 1}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {attachments && attachments.length > 0 && (
              <div style={{ marginBottom: "40px" }}>
                <h3 style={{
                  color: "#2c3e50",
                  marginBottom: "20px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  borderBottom: "3px solid #9b59b6",
                  paddingBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px"
                }}>
                  <div style={{
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <i className="mdi mdi-file-multiple" style={{ fontSize: "18px", color: "white" }}></i>
                  </div>
                  المرفقات ({attachments.length})
                </h3>

                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "15px",
                  justifyContent: "flex-start"
                }}>
                  {attachments.map((attachment, index) => {
                    let icon = "📄";
                    let bgColor = "#6c757d";
                    if (attachment.includes(".pdf")) {
                      icon = "📕";
                      bgColor = "#dc3545";
                    } else if (attachment.includes(".xls") || attachment.includes(".xlsx")) {
                      icon = "📊";
                      bgColor = "#28a745";
                    } else if (attachment.includes(".doc") || attachment.includes(".docx")) {
                      icon = "📘";
                      bgColor = "#007bff";
                    }

                    return (
                      <div key={index} style={{
                        background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                        borderRadius: "12px",
                        padding: "15px",
                        border: "1px solid rgba(155,89,182,0.2)",
                        boxShadow: "0 3px 10px rgba(0,0,0,0.05)",
                        textAlign: "center",
                        minWidth: "140px",
                        flex: "0 0 auto"
                      }}>
                        <div style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: `linear-gradient(135deg, ${bgColor} 0%, ${bgColor}dd 100%)`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "0 auto 10px",
                          boxShadow: "0 3px 8px rgba(0,0,0,0.2)"
                        }}>
                          <span style={{ fontSize: "16px" }}>{icon}</span>
                        </div>
                        <h6 style={{
                          color: "#9b59b6",
                          fontWeight: "bold",
                          marginBottom: "8px",
                          fontSize: "12px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}>
                          {attachment.split('/').pop()}
                        </h6>
                        <a href={`${FILE_BASE_URL}/uploads/attachments/${attachment}`} target="_blank" rel="noopener noreferrer" style={{
                          background: "linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)",
                          color: "white",
                          padding: "6px 12px",
                          borderRadius: "15px",
                          textDecoration: "none",
                          fontSize: "11px",
                          fontWeight: "500",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "4px",
                          boxShadow: "0 3px 8px rgba(155,89,182,0.3)",
                          transition: "transform 0.2s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                        >
                          <i className="mdi mdi-download" style={{ fontSize: "12px" }}></i>
                          تحميل
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default UserViewActivist;
